import React, { useState } from 'react'
import { Query } from 'react-apollo'
import moment from 'moment'
import { Col, Input as Ip, Select } from 'antd'
import _ from 'lodash'
import InfiniteScroll from 'react-infinite-scroller'
import {
  Div, H3, Button, Loading, DynamicButtonLink, P, H4, H5,
} from 'konsys-ui'
import Axios from 'axios'
import fileDownload from 'js-file-download'
import { theme } from '../../../styles/_variables'
import '../list/style-css.css'
import { Wrapper } from '../../../components/truck-components'
import { TRUCK_INFO } from '../../../constants/graphql/query'
import { getAccessToken, getURL } from '../../../utils/local-data-service'

const { color } = theme

const calculateTime = (startTime, endTime) => {
  let timeTh = ''
  let properEndTime = endTime
  let properStartTime = startTime
  if (endTime == null) properEndTime = moment()
  if (moment(properEndTime).diff(properStartTime, 'years') > 0) {
    timeTh += moment(properEndTime).diff(properStartTime, 'years')
    timeTh += ' ปี '
    properStartTime = moment(properStartTime).add(moment(properEndTime).diff(properStartTime, 'years'), 'years')
  }
  if (moment(properEndTime).diff(properStartTime, 'months') > 0) {
    timeTh += moment(properEndTime).diff(properStartTime, 'months')
    timeTh += ' เดือน '
    properStartTime = moment(properStartTime).add(moment(properEndTime).diff(properStartTime, 'months'), 'months')
  }
  timeTh += moment(properEndTime).diff(properStartTime, 'days')
  timeTh += ' วัน '
  return timeTh
}

export default ({ props }) => {
  const [sorted, setSorted] = useState([{ id: 'id', desc: false }])
  const [isLoading, setIsLoading] = useState(false)
  const download = () => {
    setIsLoading(true)
    setIsLoading(true)
    Axios({
      method: 'GET',
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
      },
      url: `${getURL().FILE_SERVER}/download/excel/truck/shippingorders/${props.match.params.id}`,
    }).then((resp) => {
      fileDownload(resp.data, 'รายงานข้อมูลการใช้งานรถบรรทุก.xlsx')
      setIsLoading(false)
    })
  }

  return (
    <Wrapper overflow padding='0 0 40px 0' flex>
      <Query
        query={TRUCK_INFO}
        fetchPolicy='cache-and-network'
        variables={{
          id: props.match.params.id,
        }}
      >
        {
          ({
            error, loading, data, refetch,
          }) => {
            if (error) return <p>เกิดข้อผิดพลาด</p>
            if (loading && _.isEmpty(data)) return <Loading center='true' />
            const truckInfo = data.TruckInfo
            const usageList = data.TruckInfo.trailerUsedLog
            return (
              <Div display='flex' flexDirection='column'>
                <Div display='flex' flexDirection='row' justifyContent='space-between' alignItems='center' padding='0'>
                  <H3 bold color={color.primaryColor} margin='32px 0'>หัวลาก - ประวัติการใช้งาน</H3>
                  {/* <Div display='flex' flexDirection='row' justifyContent='space-between'>
                    <Button loading={isLoading} icon="fas fa-download" text="ดาวน์โหลดข้อมูล" type="primary" onClick={() => {
                      download()
                    }} />
                  </Div> */}
                </Div>
              <Div>
                <Div display='flex' flexDirection='row' margin='8px 0 32px 8px'>
                  <H4>ทะเบียนหัว - {truckInfo.plateNumber}</H4>
                </Div>
                <Div display='flex' flexDirection='row' margin='8px 0 24px'>
                  <Col md={{ span: 4 }}><Div display='flex' justifyContent='center'><P bold color={color.primaryColor}>วันที่เริ่มใช้งาน</P></Div></Col>
                  <Col md={{ span: 4 }}><Div display='flex' justifyContent='center'><P bold color={color.primaryColor}>วันที่เลิกใช้งาน</P></Div></Col>
                  <Col md={{ span: 4 }}><Div display='flex' justifyContent='center'><P bold color={color.primaryColor}>ทะเบียนหัว</P></Div></Col>
                  <Col md={{ span: 4 }}><Div display='flex' justifyContent='center'><P bold color={color.primaryColor}>ทะเบียนหาง</P></Div></Col>
                  <Col md={{ span: 4 }}><Div display='flex' justifyContent='center'><P bold color={color.primaryColor}>ระยะเวลา</P></Div></Col>
                </Div>
                {/* <InfiniteScroll
                  loadMore={() => {
                    dataShow += 10
                    showData = usageList.slice(0, 1)
                    showData = loadMoreLog(usageList)
                  }}
                  hasMore={usageList.length < dataShow}
                  loader={<Loading center='true' />}
                  initialLoad={false}
                  style={{ width: '100%' }}
                > */}
                {
                  _.map(usageList, v => <Div display='flex' flexDirection='row' margin='8px 0 16px'>
                    <Col md={{ span: 4 }}><Div display='flex' justifyContent='center'><P>{moment(v.start).format('DD/MM/YYYY')}</P></Div></Col>
                    <Col md={{ span: 4 }}><Div display='flex' justifyContent='center'><P>{v.end != null ? moment(v.end).format('DD/MM/YYYY') : 'ใช้ปัจจุบัน'}</P></Div></Col>
                    <Col md={{ span: 4 }}><Div display='flex' justifyContent='center'><P>{truckInfo.plateNumber}</P></Div></Col>
                    <Col md={{ span: 4 }}><Div display='flex' justifyContent='center'><P>{v.trailer.trailerPlate}</P></Div></Col>
                    <Col md={{ span: 4 }}><Div display='flex' justifyContent='center'><P>{calculateTime(v.start, v.end)}</P></Div></Col>
                  </Div>)
                }
                </Div>
              </Div>
            )
          }
        }
      </Query>
    </Wrapper>
  )
}
